import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import * as getTime from '~/skills/getTime';
import * as getStatus from '~/skills/getStatus';
import { re_num } from '~/skills/TextRules';
import Actions from '~/Actions';
import Actions_Wind from '~/Actions_Wind';
import Actions_Wind_V2 from '~/Actions_Wind_V2';
import PageTitle from '~/components/PageTitle';
import SearchBar from '~/components/SearchBar';
import AddRes from '~/components/Dialog/AddRes';
import EditRes from '~/components/Dialog/EditRes';
import { EAA_Item, EAA_ItemContainer, EAA_Select, EAA_Row, EAA_TitleText, EAA_Date, EAA_Memo, EAA_Input, EAA_ErrorText, EAA_Upload, EAA_Status, EAA_UpdateTime, EAA_BottomBtn } from '~/components/EditAndAddItem';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';

import Sub1 from './Sub1';
import Sub2 from './Sub2';

import Planning from './Planning';
import Actual from './Actual';

import { returnMonthAry, returnWeekAry } from './Planning/skill';
import NoteDialog from './Actual/NoteDialog';

const modeInfo = {
  add: {
    title: '工程進度時程規劃新增',
  },
  edit: {
    title: '工程進度時程規劃編輯',
  },
  view: {
    title: '工程進度時程規劃檢視',
  },
};

const unit = (data = {}) => {
  switch (data.proj_item) {
  case '工程設計':return '';
  case '水下基礎_基樁':return '支';
  case '水下基礎_套筒(含TP段)':return '座';
  case '輸出海纜':return '條';
  case '陣列海纜':return '條';
  case '風力機_塔架':return '座';
  case '風力機_機艙':return '座';
  case '風力機_葉片':return '座';
  case '風力機':return '座';
  case '海上變電站':return '座';
  case '陸上升壓站':return '座';
  default :return '';
  }
};

const defaultWPhases = ['製造', '運輸', '安裝'];

class AddAndEdit extends Component {
  state = {
    data: {},
    old_data: {},
    mode: '',
    canSend: true,
    errorAry: [],
    workingPhases: ['製造', '運輸', '安裝'],
    phaseDisabled: false,
  }
  
  componentDidMount () {
    const { id, getBaseData, getProjectProgressIdDetail, mode = '', setPageText, getAProIdDetail, getAProList, getWindTurbineNum } = this.props;
    setPageText(modeInfo[mode].title);
    getBaseData();
    getWindTurbineNum(Actions_Wind.wind_id());
    getAProList({
      page: 1,
      per_page: 1088,
      body: {
        sort: 'desc',
        sort_field: 'upd_time',
      },
      windId: Actions_Wind.wind_id(),
    });
    // getAProIdDetail();
    if (mode !== 'add')getProjectProgressIdDetail(id);
  }

  componentDidUpdate (preProps) {
    const { ProjectProgressIdDetail: preProjectProgressIdDetail = {} } = preProps;
    const { ProjectProgressIdDetail = {}, mode } = this.props;
    if (Object.keys(preProjectProgressIdDetail).length === 0 && Object.keys(ProjectProgressIdDetail).length > 0 && (mode !== 'add')) {
      this.setState({ data: ProjectProgressIdDetail, old_data: ProjectProgressIdDetail });
    }
  }

  componentWillUnmount () {
    const { clearKey } = this.props;
    clearKey('ProjectProgressIdDetail');
    clearKey('PageText');
  }

  _onClose=() => {
    this.props._onClose();
  }

  changeData=({ label = '', data = '' }, func = () => {}) => {
    const { data: body } = this.state;
    const newBody = {
      ...body,
      [label]: data,
    };

    console.log('body', body);

    let newPhaseArry = defaultWPhases.slice();
    let newPhaseDisabled = false;

    const { proj_item = '', nation_made = '' } = newBody;
    console.log('proj_item', proj_item);
    console.log('nation_made', nation_made);

    if (nation_made === '中華民國' || nation_made === '台灣') {
      newPhaseArry = defaultWPhases.filter(x => x !== '運輸');
    }

    if (proj_item === '風力機') {
      newPhaseArry = defaultWPhases.filter(x => !(x === '運輸' || x === '製造'));
    }

    if (proj_item === '工程設計' || proj_item === '併網') {
      newPhaseDisabled = true;
      newPhaseArry = [];
    }
    

    // Actions_Wind_V2.getWorkingPhase({
    //   data: {
    //     country_name: nation_made,
    //     item: proj_item
    //   }
    // }).then(res => {
    //   console.log(res);
    // });

    this.setState({ data: newBody, workingPhases: newPhaseArry, phaseDisabled: newPhaseDisabled }, func);
  }

  getSendBody=() => {
    const { schedule_status } = this.props;
    const { data, old_data } = this.state;
    let sub3 = JSON.parse(JSON.stringify(data.sub3 || []));
    let sub5 = JSON.parse(JSON.stringify(data.sub5 || []));
    const update_order = (parseInt(old_data.update_order || '0') + 1).toString() || '';

    const returnAry = ({ func, textId }) => func({ start: moment(new Date(data.plan_start_date)), end: moment(new Date(data.plan_end_date)), data }).map(o => ({
      plan_date: getTime.getType3Time(new Date()),
      plan_desc: document.getElementById(textId).value,
      plan_num: o.num.length > 0 ? o.num : o.plan_num,
      plan_yyyymm: o.plan_yyyymm,
      // update_order: re_num(o.update_order) ? (parseInt(o.update_order || '0') + 1).toString() : '1',
      update_order,
      actural_num: o.actural_num,
      note: o.note,
      id: o.id,
    }));
    switch (schedule_status) {
    case '1':
      sub3 = returnAry({ func: returnMonthAry, textId: 'Page_ProjectProgress_memo_month' });
      break;
    case '2':
      sub3 = returnAry({ func: returnMonthAry, textId: 'Page_ProjectProgress_memo_month' });
      sub5 = returnAry({ func: returnWeekAry, textId: 'Page_ProjectProgress_memo_week' });
      break;
    case '3':
      sub3 = returnAry({ func: returnMonthAry, textId: 'Page_ProjectProgress_memo_month' });
      sub5 = returnAry({ func: returnWeekAry, textId: 'Page_ProjectProgress_memo_week' });
      break;
    default :break;
    }

    const body = {
      proj_item: data.proj_item || '',
      proj_stage: data.proj_stage || '',
      nation_made: data.nation_made || '',
      company_made: data.company_made || '',
      plan_start_date: data.plan_start_date || '',
      plan_end_date: data.plan_end_date || '',
      plan_allnum: data.plan_allnum || '',
      total_allnum: data.total_allnum || '',
      map_upload_imgs: data.map_upload_imgs || [],
      map_upload_files: data.map_upload_files || [],
      sub1: data.sub1 || [],
      sub2: data.sub2 || [],
      sub3: sub3 || [],
      sub4: data.sub4 || [],
      sub5: sub5 || [],
      // update_order: (parseInt(old_data.update_order || '0') + 1).toString() || '',
      update_order,
      plan_allnum_unit: unit(data) || '',
      total_allnum_unit: unit(data) || '',

      plan_update_desc: '',

      windcontract_id: Actions_Wind.wind_id(),
    };
    return body;
  }

  add=(status = {}) => {
    this.setState({ canSend: false });
    const body = { ...this.getSendBody(), ...status };
    this.props.postAddNewProjectProgress(body);
  }

  goToCheck=() => this.setState({ mode: 'check' }, () => this.filterError())
  goToEdit=() => this.setState({ mode: '', errorAry: [] });
  edit=(status = {}) => {
    this.setState({ canSend: false });
    const { id, putProjectProgressIdDetail } = this.props;
    const body = { ...this.getSendBody(), ...status };
    putProjectProgressIdDetail(id, body);
  }

  filterError=() => {
    const { schedule_status } = this.props;
    const { data = {} } = this.state;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const errorAry = [
      returnInputValue(data.proj_item) === '', // 0 項目
      returnInputValue(data.proj_stage) === '', // 1 階段
      data.proj_stage === '製造' && returnInputValue(data.nation_made) === '', // 2 製造國家
      data.proj_stage === '製造' && returnInputValue(data.company_made) === '', // 3 製造廠商
      (data.proj_item || '').match('海纜') && (data.map_upload_imgs || []).length === 0, // 4 海纜線路點為坐標說明
      (data.proj_item || '').match('海纜') && (data.map_upload_files || []).length === 0, // 5 上傳座標檔
      returnInputValue(data.plan_start_date) === '', // 6 規劃起始日期
      returnInputValue(data.plan_end_date) === '', // 7 規劃完成日期
      (returnInputValue(data.plan_start_date) !== '') && (returnInputValue(data.plan_end_date) !== '') && (getTime.returnDate(data.plan_start_date) > getTime.returnDate(data.plan_end_date)), // 8 『規劃起始日期』 大於 『規劃完成日期』
      returnInputValue(data.plan_allnum) === '', // 9 預計完成數量
      returnInputValue(data.total_allnum) === '', // 10 累計完成數量
      (schedule_status === '1' || schedule_status === '2' || schedule_status === '3') && (document.getElementById('Page_ProjectProgress_memo_month') || {}).value.length === 0, // 11 規劃更新進度說明_月
      (schedule_status === '2' || schedule_status === '3') && (document.getElementById('Page_ProjectProgress_memo_week') || {}).value.length === 0, // 12 規劃更新進度說明_週
    ];
    this.setState({ errorAry });
    return errorAry.indexOf(true) !== -1;
  }

  render () {
    const { PPPlanProjectList = [], ForeignBoatNationList = [], mode = '', schedule_status, AProList, WindTurbineNum } = this.props;
    const { data = {}, old_data = {}, canSend, errorAry } = this.state;
    const isCheck = this.state.mode === 'check';
    const disabled = mode === 'view' || isCheck || (!getStatus.canEdit(data));
    const disabled_date = mode === 'edit';
    const checkChange = label => isCheck ? (data[label] || '') !== (old_data[label] || '') : false;
    const checkFilesChange = label => isCheck ? JSON.stringify(data[label] || []) !== JSON.stringify(old_data[label] || []) : false;
    const checkSubChange = (n, ary = []) => isCheck ? JSON.stringify(data[`sub${n}`] || ary) !== JSON.stringify(old_data[`sub${n}`] || ary) : false;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const returnForceOpen = ({ least = 0, most = 0 }) => {
      for (let i = 0; i < errorAry.length; i++) {
        if (i >= least && i <= most && errorAry[i]) return true;
      }
      return false;
    };
    const allRight = errorAry.indexOf(true) === -1;
    const titleWidth = 170;
    const errorLeft = 20 + titleWidth;

    const returnNum = text => re_num(text) ? parseInt(text) : 0;
    const percentage = returnNum(data.plan_allnum) > 0 ? ((returnNum(data.total_allnum) / returnNum(data.plan_allnum)) * 100).toFixed(2) : 0.00;

    return (
      <div style={{
        position: 'absolute',
        left: 13,
        right: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        overflow: 'auto',
      }}
      >
        <PageTitle text={modeInfo[mode].title} />
        <div style={{ height: 8 }} />

        <SearchBar defaultOpen forceOpen={returnForceOpen({ least: 0, most: 5 })}>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='項目' bol haveChange={checkChange('proj_item')} />
                <EAA_Select displayBorder disabled={disabled} list={PPPlanProjectList} value={data.proj_item} onChange={data => {
                  this.changeData({ label: 'proj_item', data });
                }} />
              </EAA_ItemContainer>
              {errorAry[0] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
            </EAA_Item>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='階段' bol haveChange={checkChange('proj_stage')} />
                {
                  this.state.workingPhases.length > 0 &&
                  <EAA_Select displayBorder disabled={disabled || this.state.phaseDisabled} list={this.state.workingPhases.map(o => ({ name: o, value: o }))} value={returnInputValue(data.proj_stage)} onChange={data => { this.changeData({ label: 'proj_stage', data }); }} />
                }
                {
                  this.state.workingPhases.length == 0 &&
                  <>{data.proj_item}不分階段!</>
                }
              </EAA_ItemContainer>
              {errorAry[1] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
            </EAA_Item>
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='製造國家' bol={data.proj_stage === '製造'} haveChange={checkChange('nation_made')} />
                <EAA_Select displayBorder disabled={disabled} list={ForeignBoatNationList} value={returnInputValue(data.nation_made)} onChange={data => { this.changeData({ label: 'nation_made', data }); }} />
              </EAA_ItemContainer>
              {errorAry[2] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
            </EAA_Item>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='製造廠商' bol={data.proj_stage === '製造'} haveChange={checkChange('company_made')} />
                <EAA_Input displayBorder disabled={disabled} value={returnInputValue(data.company_made)} onChange={data => { this.changeData({ label: 'company_made', data }); }} />
              </EAA_ItemContainer>
              {errorAry[3] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
            </EAA_Item>
          </EAA_Row>

          {(data.proj_item || '').match('海纜') && (
            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='海纜線路點位座標說明' bol haveChange={checkFilesChange('map_upload_imgs')} />
                  <EAA_Upload displayBorder disabled={disabled} hint='上傳示意圖(必填)' value={data.map_upload_imgs || []} onChange={data => this.changeData({ label: 'map_upload_imgs', data })} />
                </EAA_ItemContainer>
                {errorAry[4] && <EAA_ErrorText marginLeft={errorLeft} text='請上傳' />}
              </EAA_Item>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='上傳座標檔' bol haveChange={checkFilesChange('map_upload_files')} />
                  <EAA_Upload displayBorder disabled={disabled} hint='上傳座標檔(必填)' value={data.map_upload_files || []} onChange={data => this.changeData({ label: 'map_upload_files', data })} marginRight={8} />
                  <div style={{ marginRight: 50, cursor: 'pointer', textDecoration: 'underline', color: '#019581' }}>Excel範例下載</div>
                </EAA_ItemContainer>
                {errorAry[5] && <EAA_ErrorText marginLeft={errorLeft} text='請上傳' />}
              </EAA_Item>
            </EAA_Row>
          )}
        </SearchBar>

        {(data.nation_made === '中華民國' || data.nation_made === '台灣') && (data.proj_stage === '製造' || data.proj_stage === '安裝') && (
          <Sub1 titleWidth={titleWidth} disabled={disabled} checkSubChange={checkSubChange} changeData={this.changeData} data={data} />
        )}

        {(data.nation_made && data.nation_made.length > 0 && !(data.nation_made === '中華民國' || data.nation_made === '台灣')) && (data.proj_stage === '安裝') && (
          <Sub2 titleWidth={titleWidth} disabled={disabled} checkSubChange={checkSubChange} changeData={this.changeData} data={data} />
        )}

        <SearchBar style={{ marginTop: 8 }} text={`${(data.proj_stage || '').length > 0 ? data.proj_stage : '(階段)'} 規劃進度`} forceOpen={returnForceOpen({ least: 6, most: 11 })}>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='規劃起始日期' bol haveChange={checkChange('plan_start_date')} />
                <EAA_Date
                  displayBorder
                  disabled={disabled || disabled_date}
                  value={getTime.returnDate(data.plan_start_date)}
                  onChange={data => this.changeData({ label: 'plan_start_date', data: getTime.getType3Time(data) }) }
                />
              </EAA_ItemContainer>
              {errorAry[6] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
              {errorAry[8] && <EAA_ErrorText marginLeft={errorLeft} text='『起始日期』不可晚於『完成日期』' />}
            </EAA_Item>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='規劃完成日期' bol haveChange={checkChange('plan_end_date')} />
                <EAA_Date
                  displayBorder
                  disabled={disabled || disabled_date}
                  value={getTime.returnDate(data.plan_end_date)}
                  onChange={data => this.changeData({ label: 'plan_end_date', data: getTime.getType3Time(data) }) }
                />
              </EAA_ItemContainer>
              {errorAry[7] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
              {errorAry[8] && <EAA_ErrorText marginLeft={errorLeft} text='『起始日期』不可晚於『完成日期』' />}
            </EAA_Item>
          </EAA_Row>
          <EAA_Row>
            {
              !this.state.phaseDisabled &&
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='預計完成數量' bol haveChange={checkChange('plan_allnum')} />
                  <EAA_Input displayBorder disabled={disabled} type='number' unit={unit(data)} value={returnInputValue(data.plan_allnum)} onChange={data => { this.changeData({ label: 'plan_allnum', data }); }} />
                </EAA_ItemContainer>
                {errorAry[9] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
              </EAA_Item>
            }
            {
              !this.state.phaseDisabled &&
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='累計已完成數量' bol haveChange={checkChange('total_allnum')} />
                  <EAA_Input displayBorder disabled={disabled} type='number' unit={unit(data)} value={returnInputValue(data.total_allnum)} onChange={data => { this.changeData({ label: 'total_allnum', data }); }} />
                </EAA_ItemContainer>
                {errorAry[10] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
              </EAA_Item>
            }
          </EAA_Row>
          {
            WindTurbineNum < data.plan_allnum &&
            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>

                  <Stack sx={{ width: '100%' }} spacing={2}>
                    <Alert severity="error" style={{ backgroundColor: '#f5c3bf' }}>
                      您好！提醒您，「預計完成數量」輸入數值 ，已超過「施工許可風力機容量 」，請再次確認。
                    </Alert>
                  </Stack>
                
                </EAA_ItemContainer>
              </EAA_Item>
            </EAA_Row>
          }
          <EAA_Row style={{ alignItems: 'start' }}>
            {(schedule_status === '1' || schedule_status === '2' || schedule_status === '3') && (
              <EAA_Item>
                <Planning {...{ data, changeData: this.changeData, disabled, errorAry, label: 'month', plan_allnum: data.plan_allnum, AProList: AProList }} />
              </EAA_Item>
            )}
            {(schedule_status === '2' || schedule_status === '3') && (
              <EAA_Item>
                <Planning {...{ data, changeData: this.changeData, disabled, errorAry, label: 'week' }} />
              </EAA_Item>
            )}
            {(schedule_status !== '2' && schedule_status !== '3') && (
              <EAA_Item>
                <Actual disabled={disabled} data={data.sub4 || []} onChange={data => this.changeData({ label: 'sub4', data })} percentage={percentage} />
              </EAA_Item>
            )}
          </EAA_Row>
          {/* {(schedule_status === '2' || schedule_status === '3') && (
            <EAA_Row>
              <EAA_Item>
                <Actual disabled={disabled} data={data.sub4 || []} onChange={data => this.changeData({ label: 'sub4', data })} percentage={percentage} />
              </EAA_Item>
            </EAA_Row>
          )} */}
        </SearchBar>

        <div style={{ height: 16 }} />

        <EAA_Status data={data} />
        <EAA_UpdateTime data={data} />

        <EAA_BottomBtn
          {...{
            data,
            mode,
            isCheck,
            allRight,
            canSend,
            onClose: this._onClose,
            goToCheck: this.goToCheck,
            goToEdit: this.goToEdit,
            add: this.add,
            edit: this.edit,
          }}
        />

        <AddRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PostAddNewProjectProgress' />
        <EditRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PutProjectProgressIdDetail' />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  PPPlanProjectList: state.data?.PPPlanProjectListV2?.items || [],
  ForeignBoatNationList: state.data?.ForeignBoatNationList,
  ProjectProgressIdDetail: state.data?.ProjectProgressIdDetail,
  schedule_status: (state.data.WindIdDetail || {}).schedule_status,
  AProList: state.data.AProList,
  WindTurbineNum: state.data.WindTurbineNum,
});
const mapDispatchToProps = dispatch => ({
  clearKey: key => Actions.clearKey(dispatch, { key }),
  setPageText: text => Actions.setPageText(dispatch, { text }),
  getBaseData: () => {
    Actions_Wind.getForeignBoatNationList(dispatch);
    Actions_Wind.getPPPlanFirstList(dispatch);
    Actions_Wind.getPPPlanSecondList(dispatch);
  },
  getProjectProgressIdDetail: id => Actions_Wind.getProjectProgressIdDetail(dispatch, { id }),
  postAddNewProjectProgress: body => Actions_Wind.postAddNewProjectProgress(dispatch, { body }),
  getAProIdDetail: id => Actions_Wind.getAProIdDetail(dispatch, { id }),
  getAProList: body => Actions_Wind.getAProList(dispatch, body),
  getWindTurbineNum: wind_id => Actions_Wind_V2.Gis.getWindTurbineNum(dispatch, wind_id),
  putProjectProgressIdDetail: (id, body) => Actions_Wind.putProjectProgressIdDetail(dispatch, { id, body }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddAndEdit);
